import { getUserCompanyList } from '@/common/js/util';

export const searchColumns = (ctx) => {
  return [
    {
      prop: 'depositCompanyNo',
      name: '公司名称',
      type: 'select',
      options: getUserCompanyList(),
      clearable: true,
      filterable: true,
      changeMethod: 'changeMethod',
      method: 'post',
    },
    {
      prop: 'depositDepartmentNo',
      name: '部门',
      type: 'select',
      options: ctx.departList,
      clearable: true,
      filterable: true,
      disabled: !ctx.queryData.depositCompanyNo,
    },
    // {
    //   name: '合同类型',
    //   prop: 'contractType',
    //   type: 'select',
    //   placeholder: '全部',
    //   options: [
    //     { value: '01', label: '租赁合同' },
    //     { value: '02', label: '物业合同' },
    //   ],
    // },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '合同名称',
      prop: 'contractName',
      type: 'input',
    },
    {
      prop: 'customerName',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'customer',
      isMultiple: true,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo.departmentCode,
        // partnerTypes: 'HZHB03,HZHB01',
      },
    },
    {
      name: '合同状态',
      type: 'dict',
      dictType: 'PROPERTY-CONTRACT-STATUS',
      placeholder: '全部状态',
      prop: 'contractStatus',
    },
  ];
};

export const auditDialogFormCells = (ctx) => {
  //0退回1罚没
  let dialogType = ctx.dialogType;
  return [
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
      span: 12,
      disabled: true,
    },

    {
      prop: 'customerName',
      type: 'input',
      name: '客户名称',
      span: 12,
      disabled: true,
    },
    {
      prop: 'depositAmount',
      type: 'input',
      name: '押金金额',
      disabled: true,
      span: 12,
    },
    {
      name: '押金余额',
      type: 'input',
      prop: 'depositBalance',
      disabled: true,
      span: 12,
    },
    {
      prop: '',
      type: 'placeholder',
      name: '',
      span: 12,
    },
    {
      prop: 'applicationAmount',
      type: 'inputNumber',
      name: dialogType == 0 ? '申请退回金额' : '申请罚没金额',
      span: 12,
      precision: 2,
    },
    {
      name: '申请原因',
      type: 'input-area',
      prop: 'reason',
      span: 24,
    },
  ];
};

export const defaultTableColumns = () => {
  return [
    {
      field: 'depositNo',
      title: '押金编号',
      width: '140',
    },
    {
      field: 'contractNo',
      title: '合同编号',
      width: '140',
    },
    {
      field: 'depositCompanyName',
      title: '公司',
      width: '140',
    },
    {
      field: 'depositDepartmentName',
      title: '部门',
      width: '140',
    },
    {
      field: 'contractName',
      title: '合同名称',
      width: '200',
    },
    {
      field: 'contractType',
      title: '合同类型',
      width: '140',
    },
    {
      field: 'customerName',
      title: '客户名称',
      width: '140',
    },
    {
      field: 'signPartyName',
      title: '签约方',
      width: '140',
    },

    //前端特殊处理
    //leaseDateFrom-leaseDateUntil
    {
      field: 'leaseDuration',
      title: '租赁期限',
      width: '280',
    },
    {
      field: 'depositAmount',
      title: '押金金额',
      width: '140',
    },
    {
      field: 'depositBalance',
      title: '押金余额',
      width: '140',
    },
    {
      field: 'contractStatus',
      title: '合同状态',
      width: '140',
      fixed: 'right',
    },
  ];
};
